import React from 'react';
import { g_HttpReq } from '../utils/httpUtils';

class apiGeoZones {
  async apiGeoZonesGet(props = {}) {
    return g_HttpReq.fetchGetJson('/system/geozones', props);
  }

  async apiGeoZoneCreate(props = {}) {
    return g_HttpReq.fetchPostJson('/system/geozones', props);
  }

  async apiGeoZonesDelete(props = {}) {
    return g_HttpReq.fetchDeleteJson('/system/geozones', props);
  }

  async apiGeoZonesUpdate(props = {}) {
    return g_HttpReq.fetchPatchJson('/system/geozones', props);
  }

  async apiGeoFenceGet(props = {}) {
    return g_HttpReq.fetchGetJson('/system/geofence-report', props);
  }
}

const g_geoZones = new apiGeoZones();
export default g_geoZones;
